import React from "react";
import { Link, ReportBanner, useThemeMode } from "@sscs/ui";
import { ReportExportButton } from "Modules/download";
import styles from "./publicReportBanner.module.scss";

type PublicReportBannerProps = {
  loginTo: string;
  exportedVersion: Pick<
    React.ComponentProps<typeof ReportExportButton>,
    "versionId" | "isRepro"
  > | null;
  children?: React.ReactNode;
};

function PublicReportBanner({
  loginTo,
  exportedVersion,
  children,
}: PublicReportBannerProps): React.JSX.Element {
  const { mode, toggleAppearance } = useThemeMode();

  return (
    <ReportBanner
      themeToggle={{ mode, onToggle: toggleAppearance }}
      actions={
        <div className={styles.buttons}>
          <Link to={loginTo} className={styles["login-link"]} underline="none">
            Login
          </Link>
          {exportedVersion && (
            <ReportExportButton
              versionId={exportedVersion.versionId}
              isRepro={exportedVersion.isRepro}
              fileType="VERSION"
              className={styles["export-button"]}
            />
          )}
        </div>
      }
    >
      {children}
    </ReportBanner>
  );
}

export default PublicReportBanner;
